export enum AppVersionTestIds {
  NEW_VERSION_POPPER = 'new-app-version-popper',
  NEW_VERSION_RELOAD = 'new-app-version-reload',
  NEW_VERSION_CLOSE = 'new-app-version-close',
}
